import React from "react"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { PayerStatus } from "@common-shared/config/oneVerify/oneVerifyPayerStatus.config"

import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { PAYER_STATUS_CONFIG } from "../../config/payerStatus.config"
import { HtmlHelper } from "../../helpers/html.helper"

export const PayerStatusBadgeComponent: React.FunctionComponent<
    IPayerStatusBadgeComponentProps
> = props => {
    const statusConfig = PAYER_STATUS_CONFIG.statuses[props.status]

    return HtmlHelper.getHtmlWrappedBadge(
        <div className="flex items-center gap-[6px]">
            <FontAwesomeIcon
                icon={statusConfig.icon}
                className="text-[12px]"
                style={{ color: statusConfig.color }}
            />

            <PrimaryText typography="textSmallSemibold">
                {statusConfig.badgeLabel}
            </PrimaryText>
        </div>,
        undefined,
        undefined,
        `w-fit ${props.className || ""}`,
        statusConfig.badgeClassName,
    )
}

interface IPayerStatusBadgeComponentProps {
    className?: string
    status: PayerStatus
}
